import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Avatar from '../../../../components/Avatar';
import BasicTextArea from '../../../../components/BasicTextArea';
import KeyCode from '../../../../constants/keys';

const CommentForm = React.forwardRef((props, ref) => {
  const {
    disabled,
    candidateName = '',
    candidatePicture,
    maxLength,
    onSend,
    isLast = false,
  } = props;
  const [value, setValue] = useState('');

  const handleChangeText = e => {
    if (!disabled) {
      const { value } = e.target;
      const str =
        value.length > maxLength ? value.substring(0, maxLength) : value;
      e.preventDefault();
      setValue(str);
    }
  };

  const handleKeyPress = e => {
    if (KeyCode.ENTER === e.key && !disabled) {
      if (e.ctrlKey) {
        setValue(value + '\r\n');
      } else {
        e.preventDefault();
        if (value.replace(/\r\n/g, '').length) {
          setValue('');
          onSend(value);
        }
      }
    }
  };

  return (
    <div
      className={isLast ? 'comment-form' : 'comment-form comment-form--middle'}
    >
      <div className="comment-form__user-avatar">
        <Avatar size={38} name={candidateName} image={candidatePicture} />
      </div>
      <div className="comment-form__form">
        <div className="comment-form__container">
          <BasicTextArea
            ref={ref}
            rows={1}
            name="new comment"
            content={value}
            resize={false}
            placeholder="Write a comment"
            controlFunc={handleChangeText}
            isValid={true}
            onKeyPressHandler={handleKeyPress}
          />
        </div>
      </div>
    </div>
  );
});

CommentForm.propTypes = {
  disabled: PropTypes.bool,
  candidateName: PropTypes.string,
  candidatePicture: PropTypes.string.isRequired,
  maxLength: PropTypes.number.isRequired,
  onSend: PropTypes.func.isRequired,
};

export default CommentForm;
